
      import API from "!../../../style-loader/dist/runtime/injectStylesIntoStyleTag.js";
      import domAPI from "!../../../style-loader/dist/runtime/singletonStyleDomAPI.js";
      import insertFn from "!../../../style-loader/dist/runtime/insertBySelector.js";
      import setAttributes from "!../../../style-loader/dist/runtime/setAttributesWithAttributesAndNonce.js";
      import insertStyleElement from "!../../../style-loader/dist/runtime/insertStyleElement.js";
      
      import content, * as namedExport from "!!../../../css-loader/dist/cjs.js!../../../postcss-loader/dist/cjs.js??ruleSet[1].rules[1].use[2]!./imagecustomresizeform.css";
      
      

var options = {"attributes":{"data-cke":true}};

;
options.setAttributes = setAttributes;
options.insert = insertFn.bind(null, "head");
options.domAPI = domAPI;
options.insertStyleElement = insertStyleElement;

var update = API(content, options);



export * from "!!../../../css-loader/dist/cjs.js!../../../postcss-loader/dist/cjs.js??ruleSet[1].rules[1].use[2]!./imagecustomresizeform.css";
       export default content && content.locals ? content.locals : undefined;
